import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkTableModule } from '@angular/cdk/table';
import { MaterialModule } from './material.module';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from './dialogs/alert-dialog/alert-dialog.component';
import { LoaderDialogComponent } from './dialogs/loader-dialog/loader-dialog.component';
import { UploadHistoryComponent } from './uploadhistory/uploadhistory.component';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
    declarations: [
        ConfirmDialogComponent,
        AlertDialogComponent,
        UploadHistoryComponent,
        LoaderDialogComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CdkTableModule,
        MaterialModule,
        MatDialogModule,
        MatPaginatorModule
    ],
    exports: [
        MaterialModule,
        ReactiveFormsModule,
        ConfirmDialogComponent,
        AlertDialogComponent,
        MatDialogModule,
        LoaderDialogComponent,
    ]
})

export class SharedModule {
}
